/** `node:fs`, backed by ./vfs.ts. Only the calls sibyl makes. */
import { enoent, files, get, list, mkdirp, norm, put, remove } from "./vfs"

type Enc = BufferEncoding | { encoding?: BufferEncoding | null } | undefined

export function existsSync(p: string): boolean {
  return get(String(p)) !== undefined
}
export function readFileSync(p: string | URL, _enc?: Enc): string {
  const e = get(String(p))
  if (e === undefined || e.kind !== "file") throw enoent("open", String(p))
  return e.data ?? ""
}
export function writeFileSync(p: string, data: string | Uint8Array, opts?: { mode?: number } | string): void {
  const text = typeof data === "string" ? data : new TextDecoder().decode(data)
  put(String(p), text, typeof opts === "object" && opts?.mode !== undefined ? opts.mode : 0o644)
}
export function mkdirSync(p: string, _opts?: unknown): void {
  mkdirp(String(p))
}
let seq = 0
export function mkdtempSync(prefix: string): string {
  const p = `${prefix}${(++seq).toString(36).padStart(6, "0")}`
  mkdirp(p)
  return norm(p)
}
export function rmSync(p: string, _opts?: unknown): void {
  remove(String(p))
}
export function renameSync(from: string, to: string): void {
  const e = get(from)
  if (e === undefined) throw enoent("rename", from)
  put(to, e.data ?? "", e.mode)
  files.delete(norm(from))
}
export function chmodSync(p: string, mode: number): void {
  const e = get(p)
  if (e !== undefined) e.mode = mode
}
function statOf(p: string) {
  const e = get(p)
  if (e === undefined) throw enoent("stat", p)
  return {
    mode: e.mode | (e.kind === "dir" ? 0o040000 : 0o100000),
    size: (e.data ?? "").length,
    mtimeMs: e.mtimeMs,
    isFile: () => e.kind === "file",
    isDirectory: () => e.kind === "dir",
    isSymbolicLink: () => false,
  }
}
export function statSync(p: string) {
  return statOf(String(p))
}
export const lstatSync = statSync
export function realpathSync(p: string): string {
  if (get(p) === undefined) throw enoent("realpath", p)
  return norm(p)
}
export function readdirSync(p: string, opts?: { withFileTypes?: boolean }): unknown[] {
  if (get(p)?.kind !== "dir") throw enoent("scandir", p)
  const names = list(p)
  if (opts?.withFileTypes !== true) return names
  return names.map((name) => {
    const e = get(`${norm(p)}/${name}`)
    return { name, isFile: () => e?.kind === "file", isDirectory: () => e?.kind === "dir", isSymbolicLink: () => false }
  })
}
export default { existsSync, readFileSync, writeFileSync, mkdirSync, mkdtempSync, rmSync, renameSync, chmodSync, statSync, lstatSync, realpathSync, readdirSync }
